<i18n>
{
  "fr": {
    "hide-menu-label": "Masquer le menu",
    "show-menu-label": "Afficher le menu",
    "close": "Fermer",
    "zoomIn": "Zoomer",
    "zoomOut": "Dézommer",
    "centerToExtent": "Rencentrer sur la zone d'intérêt",
    "minimize-label": "Réduire le panneau",
    "maximize-label": "Agrandir le panneau"
  },
  "de": {

  }
}
</i18n>

<template>
  <div id="main-container">
    <SplashScreen v-if="loading"/>

    <div v-if="!loading" id="app">
      <div :class="isLeftPanelOpen ? 'sidebar left open' : 'sidebar left'">
        <LayerNavigation
          :isOpen="isLeftPanelOpen"
          v-on:showAboutDialog="onpenAboutPopup"
        />
        <div class="interaction-container">
          <div class="interaction-button" @click="toggleLeftPanel">
            <md-tooltip md-direction="right">{{ $t(isLeftPanelOpen ? 'hide-menu-label' : 'show-menu-label') }}</md-tooltip>
            <md-icon>reorder</md-icon>
          </div>

          <div class="interaction-button dense" @click="zoomIn">
            <md-tooltip md-direction="right">{{ $t('zoomIn') }}</md-tooltip>
            <md-icon>add</md-icon>
          </div>
          <div class="interaction-button dense" @click="centerToExtent">
            <md-tooltip md-direction="right">{{ $t('centerToExtent') }}</md-tooltip>
            <md-icon>center_focus_weak</md-icon>
          </div>
          <div class="interaction-button" @click="zoomOut">
            <md-tooltip md-direction="right">{{ $t('zoomOut') }}</md-tooltip>
            <md-icon>remove</md-icon>
          </div>

          <InteractionPanel />
        </div>
      </div>
      <div :class="['content', {'left-panel-open': isLeftPanelOpen}]">
        <Map class="content-view"/>
      </div>
      <!-- <div :class="['button-right-panel', {'show': isRightPanelOpen}, {'right-panel-wide': isRightPanelOpen && isRightPanelWide}]" @click="toggleWideRightPanel">
        <md-tooltip md-direction="left">{{ $t(isRightPanelWide ? 'minimize-label' : 'maximize-label') }}</md-tooltip>
        <md-icon v-if="!isRightPanelWide">arrow_left</md-icon>
        <md-icon v-if="isRightPanelWide">arrow_right</md-icon>
      </div> -->
      <div :class="[ 'sidebar right', { 'open': isRightPanelOpen, 'wide': isRightPanelOpen && isRightPanelWide }]">
        <ToolPanel name="sidebar-right"/>
      </div>
    </div>

    <AboutPopup :show="showAboutPopup" v-on:close="closeAboutPopup" />
  </div>
</template>

<script>

import AboutPopup from '@/components/common/about'

import ToolPanel from '@/components/tool/toolPanel'
import InteractionPanel from '@/components/interaction-button/interactionPanel'
import LayerNavigation from '@/views/map/layerNavigation'
import Map from '@/views/map/map'
import SplashScreen from '@/components/common/splash-screen'


import MapInteractionMixin from '@/mixins/store/interaction'
import CommonStoreMixin from '@/mixins/store/common'
import LayerStoreMixin from '@/mixins/store/layer'
import ToolStoreMixin from '@/mixins/store/tool'
import MapStoreMixin from '@/mixins/store/map'

import Config from '@/config.js'

export default {
  name: 'MainViewer',
  mixins: [
    LayerStoreMixin,
    ToolStoreMixin,
    MapStoreMixin,
    CommonStoreMixin,
    MapInteractionMixin
  ],
  components: {
    AboutPopup,
    LayerNavigation,
    ToolPanel,
    InteractionPanel,
    Map,
    SplashScreen
  },
  data () {
    return {
      loading: true,
      timeframeLoading: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$store.dispatch('fetchAllSources').then(() => {
        this.$store.dispatch('setStateFromQueryParams')
        setTimeout(() => {
          this.loading = false
        }, 500)
      }).catch(this.handleError)
    })
  },
  watch: {
    loading (state) {
      if (!state) setTimeout(() => { this.onLoaded() }, 1000) // SD Hack: Debounce du pauvre
    },
    selectedLayers () {
      this.updateTools()
    },
    layerGroups () {
      this.updateTools()
    }
  },
  methods: {
    onLoaded () {
      if (localStorage.getItem(Config.version) === null) {
        localStorage.setItem(Config.version, true)
        this.onpenAboutPopup()
      }
    },
    onpenAboutPopup (){
      this.setShowAboutPopup(true)
    },
    closeAboutPopup () {
      this.setShowAboutPopup(false)
    },
    onError (e) {
      console.error(e)
    },
    updateTools () {
      this.emptyTools()
      // On affiche tous les outils nécessaire dans la barre de droite pour les couches actives
      this.selectedLayers.filter((layer) => layer.getVisible() && layer.layerGroup.webviewConfig.show).forEach((layer) => this.setToolsForLayer(layer))
    }
  }
}
</script>

<style lang="scss" scoped>
.interaction-container {
  display: flex;
  flex-direction: column;

  .interaction-button {
    width: 34px;
    height: 34px;
    padding: 5px;
    cursor: pointer;
    margin-bottom: 5px;
    background-color: #ffffff;

    &.dense {
      margin-bottom: 0px;
      border-bottom: 1px solid grey;
    }
  }
}

.button-right-panel {
  display: none;

  &.show {
    display: block
  }

  &.right-panel-wide {
    right: 50vw;
  }
  right: 20vw;
  position: fixed;
  background-color: white;
  width: 34px;
  height: 34px;
  padding: 5px;
}
</style>
